import { Vue, Component, Prop } from 'vue-property-decorator'
import { CreateElement } from 'vue'
import ImageElement from '~/components/element/ImageElement'
import ProductCardCommercial from '~/types/api/ProductCardCommercial'
import MainSliderRequiredTextType from '~/types/enum/MainSliderRequiredTextType'
import ContraindicationsSvg from '~/assets/svg/contraindications.svg?inline'
import ContraindicationsMobileSvg from '~/assets/svg/contraindicationsMobile.svg?inline'
import BadSvg from '~/assets/svg/bad.svg?inline'
import BadMobileSvg from '~/assets/svg/bad-mobile.svg?inline'
import { MainSliderItem } from '~/types/api/MainSliderItem'
import general from '~/store/general'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'
import MarkingAd from '~/components/element/MarkingAd'

const requiredTextSvg = {
  [MainSliderRequiredTextType.Contraindications]: {
    desktop: ContraindicationsSvg,
    mobile: ContraindicationsMobileSvg
  },
  [MainSliderRequiredTextType.Bad]: {
    desktop: BadSvg,
    mobile: BadMobileSvg
  }
}

@Component
export default class ProductCardCommercialElem extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  readonly productCardCommercial!: MainSliderItem

  startMoveClickSlider: number = 0
  endMoveClickSlider: number = 0

  generalStore: general

  constructor () {
    super()
    this.generalStore = s(this.$store).general
  }

  get title (): string {
    return this.productCardCommercial.title
  }

  get bannerText (): string {
    return this.productCardCommercial.bannerText
  }

  mouseDown (offsetX: number) {
    this.startMoveClickSlider = offsetX
  }

  mouseMove (offsetX: number) {
    this.endMoveClickSlider = offsetX
  }

  mouseUp (e: MouseEvent, item: MainSliderItem) {
    if (Math.abs(this.startMoveClickSlider - this.endMoveClickSlider) > 20) {
      e.preventDefault()
    } else if (item.link && item.link.length > 0) {
      if (item.link.includes('24farmacia.ru')) {
        this.$router.push(item.link.split('24farmacia.ru')[1])
      } else if (item.link.match(/^(http|https):\/\//i)) {
        window.location.href = item.link
      } else {
        this.$router.push('/' + item.link)
      }
    } else if (item.promotionCode && item.promotionCode.length > 0) {
      const sectionCode = s(this.$store).regions.sectionCode
      window.location.href = '/' + sectionCode + '/stock/' + item.promotionCode
    } else if (item.categoryId && item.categoryId.length > 0) {
      const helper = new SectionHelper(this.generalStore.sections, this.$store)
      const link = helper.getSectionPathById(item.categoryId) ?? ''
      window.location.href = link
    }
  }

  renderRequiredTextBlock (h: CreateElement, item: MainSliderItem) {
    if (item.requiredTextCode && requiredTextSvg[item.requiredTextCode]) {
      return (
        <div class="product-card-commercial__contraindications-block">
          <div class="product-card-commercial__contraindications-block-mobile">
            {h(requiredTextSvg[item.requiredTextCode].mobile)}
          </div>
        </div>
      )
    }
  }

  renderImage () {
    if (this.productCardCommercial.img) {
      return (
        <ImageElement {...{
          props: {
            img: this.productCardCommercial.img,
            alt: ''
          }
        }} />
      )
    }
  }

  render (h: CreateElement) {
    return (
      <div class="product-card-commercial__list-element-commercial">
        <div class='product-card-commercial'>
          <div class="marking-ad__catalogCardAd">
            {this.productCardCommercial.marking?.id &&
              <MarkingAd {...{
                props: {
                  info: this.productCardCommercial.marking
                }
              }}/>
            }
          </div>
          <div class="product-card-commercial__info-wrapper">
            <div class="product-card-commercial__info-title">
              {this.title}
            </div>
            <div class="product-card-commercial__info-description" domPropsInnerHTML={this.bannerText}/>
          </div>
          <div class="product-card-commercial__image-wrapper"
            ondragstart={(e: Event) => {
              e.preventDefault()
            }} onmousedown={(e: MouseEvent) => {
              this.mouseDown(e.screenX)
            }} onmousemove={(e: MouseEvent) => {
              this.mouseMove(e.screenX)
            }} onmouseup={(e: MouseEvent) => {
              this.mouseUp(e, this.productCardCommercial)
            }}
          >
            {this.renderImage()}
          </div>
          {this.renderRequiredTextBlock(h, this.productCardCommercial)}
        </div>
      </div>
    )
  }
}
